import Snotify from 'vue-snotify';
import {SnotifyStyle} from 'vue-snotify';

function install(Vue, config) {
    if (install.installed) {
        return;
    }
    install.installed = true;

    Vue.use(Snotify, config);

    Vue.prototype.$snotify.validation = function (errors, title) {
        let message = [];
        for (let prop in errors) {
            if (!errors.hasOwnProperty(prop)) {
                continue;
            }

            message = message.concat(errors[prop])
        }

        this.html(`
            <div class="snotifyToast__title"><b>${title}</b></div>
            <div class="snotifyToast__body"><ul><li>${message.join('</li><li>')}</li></ul></div>
            `,
            {
                type: SnotifyStyle.error,
            }
        );
    };
}

export default install;
